import React from 'react';
import PropTypes from 'prop-types';
import FontAwesome from 'react-fontawesome';

const FALabel = (props) => {
  const {
    icon,
    iconFirst,
    label,
    className,
    ...rest
  } = props;

  return (
    <span className={className}>
      { iconFirst && <FontAwesome name={icon} {...rest} /> }
      {label}
      { !iconFirst && <FontAwesome name={icon} {...rest} /> }
    </span>
  );
};

FALabel.propTypes = {
  className: PropTypes.string,
  icon: PropTypes.string.isRequired,
  iconFirst: PropTypes.bool,
  label: PropTypes.string.isRequired
};

FALabel.defaultProps = {
  className: '',
  iconFirst: false
};

export default FALabel;
